import React, { useState } from 'react';
import { TextField } from '@material-ui/core';
import messages from 'containers/LawyerLegalProceedingsPage/AppealOnMerits/messages';
import { injectIntl, IntlShape } from 'react-intl';
import { translate } from 'containers/services/translate';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { DATE_FORMAT, DATE_PICKET_FORMAT } from 'constants/global';
import { dateStringToLocalDate } from 'containers/IdentificationPage/utils';
import DateFnsUtils from '@date-io/date-fns';
import frLocale from 'date-fns/locale/fr';
import moment from 'moment-timezone';
import { JudgementOnMeritsType } from 'containers/LawyerLegalProceedingsPage/typings';
import { get, isEmpty } from 'lodash';
import { getDateIgnoreTimezone } from 'containers/common/LegalProceedings/utils';
import { getLastJudgementDate } from 'containers/LawyerLegalProceedingsPage/utils';
import { validationCourtFileNumber } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/utils';

export interface JudgementOnMeritsFormProps {
  intl: IntlShape;
  judgementOnMeritsInfoForm: any;
  setJudgementOnMeritsInfoForm: Function;
  judgementOnMerits: JudgementOnMeritsType;
  isReadOnly: boolean;
  judgementAddDocuments: any;
}
const JudgementOnMeritsForm: React.FC<JudgementOnMeritsFormProps> = ({
  judgementOnMeritsInfoForm,
  judgementOnMerits,
  setJudgementOnMeritsInfoForm,
  ...props
}): JSX.Element => {
  const [errorDate, setErrorDate] = useState(false);

  const [judgementNumber, setJudgementNumber] = useState<string>(
    get(judgementOnMerits['judgementOnMerits']['jom'], 'judgementNumber', ''),
  );
  const [judgementDate, setJudgementDate] = useState<string>(
    get(judgementOnMerits['judgementOnMerits']['jom'], 'judgementDate', ''),
  );

  /* istanbul ignore next */
  const handleChange = (e: React.ChangeEvent<{ value: string }>) => {
    setJudgementNumber(e.target.value);
    setJudgementOnMeritsInfoForm({
      ...judgementOnMeritsInfoForm,
      judgementNumber: e.target.value,
    });
  };

  /* istanbul ignore next */
  const handleChangeDate = (date: Date | null) => {
    setErrorDate(false);
    const theDate = getDateIgnoreTimezone(date);
    const judgementDate = moment(theDate as Date).format(DATE_FORMAT);
    setJudgementDate(judgementDate);
    setJudgementOnMeritsInfoForm({
      ...judgementOnMeritsInfoForm,
      judgementDate,
    });
    if (!isEmpty(props.judgementAddDocuments)) {
      const jaddJudgementDate = getLastJudgementDate(
        get(props, 'judgementAddDocuments', []),
      );
      if (
        new Date(theDate) > new Date() ||
        (jaddJudgementDate && new Date(theDate) < new Date(jaddJudgementDate))
      ) {
        /* istanbul ignore next */
        setErrorDate(true);
      }
    }
  };

  return (
    <>
      <div className="correctional-judgement">
        <TextField
          id="judgement_number_field"
          label={translate(messages.judgementOnMeritsNumberFieldTitle, props)}
          onChange={handleChange}
          value={judgementNumber}
          InputProps={{ readOnly: props.isReadOnly }}
          placeholder={'NNNNNN/NNNN/NNNN'}
          error={
            judgementNumber === '' ||
            !validationCourtFileNumber(judgementNumber)
          }
          helperText={
            !validationCourtFileNumber(judgementNumber)
              ? translate(messages.courtFileNumberError, props)
              : ''
          }
        />
        <div className="judgement-on-merits-info">
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
            <KeyboardDatePicker
              autoOk
              variant="inline"
              format={DATE_PICKET_FORMAT}
              id="form-judgement-date"
              onChange={handleChangeDate}
              value={dateStringToLocalDate(judgementDate)}
              label={translate(messages.appealOnMeritsDate, props)}
              InputProps={{ readOnly: props.isReadOnly }}
              minDate={getLastJudgementDate(
                get(props, 'judgementAddDocuments', []),
              )}
              error={
                judgementDate === '' ||
                judgementDate === 'Invalid date' ||
                errorDate
              }
              helperText={
                errorDate ? translate(messages.judgementDateError, props) : ''
              }
            />
          </MuiPickersUtilsProvider>
        </div>
      </div>
    </>
  );
};

export default injectIntl(JudgementOnMeritsForm);
